import React from "react";
import { Card } from "../modules/Settings/Badges";

export function BadgeCardPage(props) {
  return <Card {...props} />;
}
